import jwtAuthAxios from "./auth/jwtAuth";

const documentServices = {};

// THIS IS FOR THE TABLE OF DOCUMENTS
documentServices.getAttributes = async () => {
  // params : none
  const {data} = await jwtAuthAxios.get("/documents/attributes");
  // Return the headers of the document table, sorted
  // Structure: [{id, numeric(bool), label(name-of-the-header)}, ...]
  return data;
};

// THIS IS FOR THE TABLE OF DOCUMENTS
documentServices.getDocuments = async (params) => {
  // params : date_from, date_to, regularization_status, documents_status, search_input
  const {data} = await jwtAuthAxios.get(`/documents${params}`);
  // Return the rows of the document table, sorted by headers
  return data;
};

// THIS IS FOR THE POP UP OF ONE DELIVERY
documentServices.getDeliveryDocuments = async (delivery_id) => {
  // delivery_id : id of the delivery
  // render json: { summary: summary, documents: documents_data }, status: :ok
  const {data} = await jwtAuthAxios.get(`/documents/delivery_documents${delivery_id}`);
  // Return the documents of the delivery in this structure
  const documentsData = {
    "Toma de conocimiento": {
      "original": {
        "present": true,
        "origin": "SOVOS",
        "destroyable": false,
        "fileUrl": "https://images.pexels.com/photos/1108099/pexels-photo-1108099.jpeg?cs=srgb&dl=pexels-chevanon-1108099.jpg&fm=jpg&_gl=1*1ujvim8*_ga*MTM2MDc0NDUzMC4xNzQxMTgzODc1*_ga_8JE65Q40S6*MTc0MTE4Mzg3NC4xLjAuMTc0MTE4Mzg3NC4wLjAuMA..",
        "warning": null,
        "error": null
      },
      "signed": {
        "present": true,
        // "present": falsekk,
        "origin": "Applicación móvil",
        "destroyable": true,
        "fileUrl": "https://images.pexels.com/photos/1108099/pexels-photo-1108099.jpeg?cs=srgb&dl=pexels-chevanon-1108099.jpg&fm=jpg&_gl=1*1ujvim8*_ga*MTM2MDc0NDUzMC4xNzQxMTgzODc1*_ga_8JE65Q40S6*MTc0MTE4Mzg3NC4xLjAuMTc0MTE4Mzg3NC4wLjAuMA..",
        "warning": null,
        "error": null
      },
      "type": null,
      "typeOptions": []
    },
    "Recepción conforme": {
      "original": {
        "present": true,
        "origin": "Carga manual",
        "destroyable": true,
        "fileUrl": "https://images.pexels.com/photos/1108099/pexels-photo-1108099.jpeg?cs=srgb&dl=pexels-chevanon-1108099.jpg&fm=jpg&_gl=1*1ujvim8*_ga*MTM2MDc0NDUzMC4xNzQxMTgzODc1*_ga_8JE65Q40S6*MTc0MTE4Mzg3NC4xLjAuMTc0MTE4Mzg3NC4wLjAuMA..",
        "warning": null,
        "error": null
      },
      "signed": {
        "present": false,
        "origin": null,
        "destroyable": false,
        "fileUrl": null,
        "error": null,
        "warning": null,
      },
      "type": "Guía de despacho",
      "typeOptions": ["Guía de despacho", "Factura"]
    }
  }
  // And this for the summary of the delivery
  // maybe this data should be asked for in another request?
  const cardData = {
    title: 'Entrega',
    partial: true,
    subtitle: '23453',
    sortedAttributes: [
      {
        title: 'Fecha de entrega',
        value: '12/12/2021'
      },
      {
        title: 'Patente',
        value: 'LKGY68'
      },
      {
        title: 'Cliente',
        value: 'Aceites Barraza'
      },
      {
        title: 'Conductor',
        value: 'Guillermo Barazarte Pérez'
      },
      {
        title: 'Transportista',
        value: 'Transportes Bretti'
      },
      {
        title: 'Pedido',
        value: '676754356'
      },
      {
        title: 'Instructivo',
        value: '84352'
      },
    ]
  }
  if (data.error) {
    return { documentsData: null, cardData: null };
  }
  return { documentsData, cardData };
  // return data;
}

// # POST /api/v1/regularizations
// def create
// Que los mande en este formato:
// params.require(:regularization).permit(:invoice_number, :credit_number, :delivery_id)
// Lo traduciría desde este:
// regularization: {documentNumber: "678", documentType: "guide"}

export default documentServices;

// Estos nros de documentos están duplicados en shipping_docs, yo creo que fueron de prueba cuando salió esta feature
//  ["3562894", "3562894", "3562894", "3562894"], //shipping_doc_kind_id: 2, 17 Apr 2023                         
//  ["3562899", "3562899", "3562899", "3562899"], //shipping_doc_kind_id: 2,  17 Apr 2023                                    
//  ["1", "1", "1", "1"],  //shipping_doc_kind_id: 2 y shipping_doc_kind_id: 1  17 Apr 2023 y  13 Jun 2023                                                        
//  ["123548", "123548", "123548", "123548"],  //shipping_doc_kind_id: 1   17 Apr 2023                                    
//  ["123550", "123550", "123550", "123550"],  //shipping_doc_kind_id: 1 17 Apr 2023
// Esto parece ser una práctica habitual, falta explicación
//  "0000000000" 19 Feb 2025 , 17 Feb 2025, 11 Feb 2025, 20 Jan 2025, 31 Dec 2024 , 24 Dec 2024, 16 Oct 2024 (y más)

// rails generate scaffold User name:string
// invoke  active_record
// create    db/migrate/20230518000000_create_users.rb
// create    app/models/user.rb

// invoke    test_unit
// create      test/models/user_test.rb
// create      test/fixtures/users.yml
// HASTA AQUÍ LO HACE EL GENERATE MODEL

// invoke  resource_route
//  route    resources :users
// invoke  scaffold_controller
// create    app/controllers/users_controller.rb

// invoke    erb
// create      app/views/users
// create      app/views/users/index.html.erb
// create      app/views/users/edit.html.erb
// create      app/views/users/show.html.erb
// create      app/views/users/new.html.erb
// create      app/views/users/_form.html.erb
// create      app/views/users/_user.html.erb

// invoke    resource_route

// invoke    test_unit
// create      test/controllers/users_controller_test.rb
// create      test/system/users_test.rb
// invoke    helper
// create      app/helpers/users_helper.rb
// invoke      test_unit

// invoke    jbuilder
// create      app/views/users/index.json.jbuilder
// create      app/views/users/show.json.jbuilder